module.exports = __webpack_public_path__ + "5c5ad23c.svg";